import React, { useState, useEffect } from 'react';
import SEO from '../components/common/SEO';
import { blogAPI } from '../utils/api';
import BlogList from '../components/blog/BlogList';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Scroll animations
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await blogAPI.getAll();
        setPosts(response.data.data || []);
      } catch (err) {
        setError(err.message || 'Failed to load blog posts');
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <>
      <SEO
        title="Blog - Confident Portraits | Photography Insights & Stories"
        description="Read about photography techniques, industry insights, personal projects, and behind-the-scenes stories from Confident Portraits."
        url="/blog"
      />
      <div className="pt-24 md:pt-28 pb-20 bg-white min-h-screen">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header with fade-in animation */}
          <div
            ref={headerRef}
            className={`text-center mb-16 md:mb-20 transition-all duration-700 ease-out ${
              headerVisible
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-8'
            }`}
          >
            <h1 className="text-4xl md:text-5xl lg:text-display font-heading font-bold text-secondary mb-6 leading-tight">
              Blog
            </h1>
            <p className="text-lg md:text-xl text-text-secondary font-body max-w-2xl mx-auto leading-relaxed">
              Industry insights, personal projects, and behind-the-scenes stories
            </p>
          </div>

          {/* Content */}
          {loading ? (
            <div className="flex justify-center py-12">
              <Loading size="lg" text="Loading blog posts..." />
            </div>
          ) : error ? (
            <ErrorMessage message={error} className="max-w-2xl mx-auto" />
          ) : (
            <BlogList posts={posts} />
          )}
        </div>
      </div>
    </>
  );
};

export default Blog;
